/**
 * 通用的Cookie数据操作方法
 */
/**
 * 获取Cookie
 * @param {string} key
 * @returns {string}
 */
export var getCookie = function (key) {
    var list = document.cookie.match(new RegExp('(?:^| )' + encodeURIComponent(key) + '=([^;]+)'));
    return list && decodeURIComponent(list[1]);
};
/**
 * 设置Cookie
 * 默认过去时间是一天，expires是以天为单位
 * 当expires为''时,代表设置的是Session Cookie
 * @param {string} key
 * @param {string} val
 * @param {number} expires
 * @param {string} path
 * @param {string} domain
 * @param {boolean} secure
 */
export var setCookie = function (key, val, expires, path, domain, secure) {
    if (val === void 0) { val = 1; }
    if (expires === void 0) { expires = 0; }
    if (path === void 0) { path = '/'; }
    if (domain === void 0) { domain = ''; }
    if (secure === void 0) { secure = false; }
    document.cookie = encodeURIComponent(key) + '=' + encodeURIComponent(String(val)) +
        (expires ? '' : "; expires=" + new Date(+new Date() + (typeof expires !== 'undefined' ? expires : 1) * 86400000).toUTCString()) +
        ("; path=" + path) +
        ("; domain=" + (domain || document.domain.split('.').slice(-2).join('.'))) +
        (secure ? "; secure" : '');
};
/**
 * 移除Cookie
 *
 * @param {string} key
 * @param {string} path
 * @param {string} domain
 * @param {boolean} secure
 */
export var removeCookie = function (key, path, domain, secure) {
    setCookie(key, '', 0, path, domain, secure);
};
